import type { MonthGroup } from '@/cmsBackend/transformers/types/featureAnnouncement';

export interface ProductUpdatesLoadMoreResult {
  monthGroup: MonthGroup | null;
  hasMore: boolean;
  nextCursor?: string;
}

export async function fetchProductUpdatesMonthGroup(
  publishedBefore: string,
  locale: string,
): Promise<ProductUpdatesLoadMoreResult> {
  const res = await fetch(
    `/mlp-cms/api/product-updates/load-more?locale=${encodeURIComponent(locale)}&publishedBefore=${encodeURIComponent(publishedBefore)}`,
  );
  if (!res.ok) {
    throw new Error(`fetchProductUpdatesMonthGroup failed: HTTP ${res.status}`);
  }
  const data = await res.json();
  return {
    monthGroup: data.monthGroup ?? null,
    hasMore: Boolean(data.hasMore),
    ...(data.nextCursor && { nextCursor: data.nextCursor }),
  };
}
